'use es6';

import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import NavMarker from 'react-rhumb/NavMarker';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import DirectorySidebarContainer from '../containers/DirectorySidebarContainer';
import SortingBar from './SortingBar';
import GoodsGrid from './GoodsGrid';
import UIButton from 'UIComponents/button/UIButton';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import UISection from 'UIComponents/section/UISection';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import Limits from '../constants/Limits';
import LoadingWrapper from './LoadingWrapper';
import PageLimitPicker from './PageLimitPicker';
import { areAllSidebarFiltersAtInitialValue, getClearedSidebarFilters, replaceAllProductsCategoryName } from '../utils/utils';
import { getCategoryOptionText } from '../utils/langUtils';
import LoadingErrorPage from './LoadingErrorPage';

var LoadingErrorComponent = function LoadingErrorComponent() {
  return React.createElement(NavMarker, {
    name: "DIRECTORY_ERROR_LOAD"
  }, React.createElement(LoadingErrorPage, null));
};

export default createReactClass({
  displayName: "DirectoryPage",
  propTypes: {
    auth: PropTypes.object.isRequired,
    directoryData: PropTypes.object.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onGoodFilterChange: PropTypes.func.isRequired,
    trackAdjustedFilter: PropTypes.func.isRequired,
    trackLinkClick: PropTypes.func.isRequired,
    categoryFilter: PropTypes.string.isRequired
  },
  handleClearFilters: function handleClearFilters() {
    this.props.onGoodFilterChange(getClearedSidebarFilters());
  },
  renderPaginatorIfMultiplePages: function renderPaginatorIfMultiplePages(directoryData, onPageChange) {
    var totalCount = directoryData.get('numGoodsMatchingFilterCriteria');
    var pageSize = directoryData.getIn(['goodFiltersAndPage', GoodFiltersAndPage.LIMIT], Limits.SMALL);
    var pageCount = Math.ceil(totalCount / pageSize);

    if (pageCount > 1) {
      return React.createElement(UIFlex, {
        justify: "center",
        align: "baseline",
        className: "text-center m-top-2"
      }, React.createElement(UIPaginator, {
        className: "integrate-directory-paginator",
        onPageChange: onPageChange,
        page: directoryData.getIn(['goodFiltersAndPage', GoodFiltersAndPage.PAGE], 0) + 1,
        pageCount: pageCount
      }), React.createElement(PageLimitPicker, {
        limit: pageSize,
        total: totalCount,
        onChange: this.props.onGoodFilterChange
      }));
    }

    return null;
  },
  renderZeroState: function renderZeroState(zeroStateType) {
    var goodFilters = this.props.directoryData.get('goodFiltersAndPage');
    var textValues = {
      categoryName: replaceAllProductsCategoryName(getCategoryOptionText(goodFilters.get(GoodFiltersAndPage.SUB_TYPE)).toLowerCase()),
      searchTerm: goodFilters.get(GoodFiltersAndPage.SEARCH_TERM)
    };
    return React.createElement(NavMarker, {
      name: "DIRECTORY_EMPTY_STATE_LOAD"
    }, React.createElement(UIErrorMessage, {
      "data-test-id": "goods-grid-empty-state",
      illustration: "empty-state-charts",
      title: unescapedText("goodsZeroState." + zeroStateType + ".title", textValues)
    }, React.createElement("p", null, React.createElement(FormattedJSXMessage, {
      message: "goodsZeroState." + zeroStateType + ".message_jsx",
      options: {
        onClick: this.handleClearFilters
      },
      elements: {
        Button: UIButton
      }
    }))));
  },
  renderGoodsGridIfResults: function renderGoodsGridIfResults() {
    var _this$props = this.props,
        directoryData = _this$props.directoryData,
        trackLinkClick = _this$props.trackLinkClick;

    if (directoryData.get('goods').size) {
      return React.createElement(NavMarker, {
        name: "DIRECTORY_GRID_LOAD"
      }, React.createElement(GoodsGrid, {
        goods: directoryData.get('goods'),
        trackLinkClick: trackLinkClick
      }));
    }

    if (directoryData.getIn(['goodFiltersAndPage', GoodFiltersAndPage.SEARCH_TERM])) {
      if (!areAllSidebarFiltersAtInitialValue(directoryData.get('goodFiltersAndPage'))) {
        return this.renderZeroState('searchWithFilters');
      }

      return this.renderZeroState('searchWithNoFilters');
    }

    if (!areAllSidebarFiltersAtInitialValue(directoryData.get('goodFiltersAndPage'))) {
      return this.renderZeroState('noSearchWithFilters');
    }

    return null;
  },
  render: function render() {
    var _this$props2 = this.props,
        auth = _this$props2.auth,
        directoryData = _this$props2.directoryData,
        onPageChange = _this$props2.onPageChange,
        onGoodFilterChange = _this$props2.onGoodFilterChange,
        categoryFilter = _this$props2.categoryFilter,
        trackAdjustedFilter = _this$props2.trackAdjustedFilter,
        trackLinkClick = _this$props2.trackLinkClick;
    return React.createElement("div", {
      className: "directory-container m-y-4"
    }, React.createElement("div", {
      className: "page-content-wrapper"
    }, React.createElement(UISection, {
      className: "directory-main-content-area"
    }, React.createElement(UIFlex, null, React.createElement(UIBox, {
      basis: "200px",
      className: "m-right-8",
      shrink: 0
    }, React.createElement(DirectorySidebarContainer, {
      auth: auth,
      onGoodFilterChange: onGoodFilterChange,
      trackAdjustedFilter: trackAdjustedFilter,
      trackLinkClick: trackLinkClick
    })), React.createElement(UIBox, {
      grow: 1
    }, React.createElement(LoadingWrapper, {
      ErrorComponent: LoadingErrorComponent,
      requestStatus: directoryData.get('requestStatus')
    }, React.createElement(UISection, null, React.createElement(SortingBar, {
      goodFilters: directoryData.get('goodFiltersAndPage'),
      numGoodsMatchingFilterCriteria: directoryData.get('numGoodsMatchingFilterCriteria', 0),
      onGoodFilterChange: onGoodFilterChange,
      categoryFilter: categoryFilter
    })), this.renderGoodsGridIfResults(), this.renderPaginatorIfMultiplePages(directoryData, onPageChange)))))));
  }
});